/** Freezes a mounted editor after fonts, images and its initial layout have settled. */
export function freezeEditorSizeAfterLayout(panel: HTMLElement): () => void {
  const previous = {width: panel.style.width, height: panel.style.height,
    boxSizing: panel.style.boxSizing, flex: panel.style.flex};
  let cancelled = false;
  let frame = 0;
  let previousWidth = -1;
  let previousHeight = -1;
  let stableFrames = 0;

  const measure = () => {
    if (cancelled || !panel.isConnected) return;
    const width = panel.offsetWidth;
    const height = panel.offsetHeight;
    if (width > 0 && height > 0 && width === previousWidth && height === previousHeight) stableFrames++;
    else stableFrames = 0;
    previousWidth = width;
    previousHeight = height;
    if (stableFrames < 2) {
      frame = requestAnimationFrame(measure);
      return;
    }
    panel.style.boxSizing = "border-box";
    panel.style.width = `${width}px`;
    panel.style.height = `${height}px`;
    panel.style.flex = "0 0 auto";
  };

  const images = Array.from(panel.querySelectorAll("img"));
  const ready = images.map(image => image.decode().catch(() => undefined));
  void Promise.all([document.fonts.ready, ...ready]).then(() => {
    if (!cancelled) frame = requestAnimationFrame(measure);
  });

  return () => {
    cancelled = true;
    cancelAnimationFrame(frame);
    Object.assign(panel.style, previous);
  };
}
